// libs
import React, { useState } from 'react';
import { useForm, Controller } from "react-hook-form";
import { ToastContainer, toast } from 'react-toastify';
import "../../assets/css/form.css";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
// config & functions 
import ajaxCall from '../../utils/ajaxcall';
import config from "../../config/index";

function FormModal({loadapidata, apidataparams, setshowformmodalbox, orgaccountid, rowid, token, orginfo}) {

    const [InputFields, setInputFields] = useState({
        rowId: "",
        code: "",
        discountType: "flat",
        discountValue: "",
        minOrderAmount: "0",
        maxDiscountAmount: "",
        expiryDate: "",
        maxUsageCount: "",
        isSingleUsePerUser: 0,
        isActive: 1
    });
    const disabledField = (orginfo.roleId === 1 || orginfo.roleId === 2) ? false : true;
    const [SubmitButton, setSubmitButton] = useState((rowid) ? 'UPDATE RECORD' : 'SAVE RECORD');
    const [Notification, setNotification] = useState({ status: (rowid) ? true : false, message: 'Please wait while we fetch your record' });
    const [DisableSubmitButton, setDisableSubmitButton] = useState(false);
    const [Show, setShow] = useState(false);

    const {
        register,
        handleSubmit,
        control,
        formState: { errors },
        reset,
        watch
    } = useForm();

    const watchDiscountType = watch('discountType', InputFields.discountType);

    const hideModal = () => {
        setShow(false);
        setshowformmodalbox(false);
    }

    const updateChangeEvent = (value, field) => {
        field.onChange(value);
    }

    const formatDateForInput = (dateStr) => {
        if (!dateStr) return '';
        const d = new Date(dateStr);
        const pad = (n) => String(n).padStart(2, '0');
        return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
    }

    const onSubmit = async (data) => {
        setSubmitButton('LOADING...');
        setDisableSubmitButton(true);
        let postData = {
            accountId: orgaccountid,
            rowId: rowid || 0,
            code: data.code,
            discountType: data.discountType,
            discountValue: data.discountValue,
            minOrderAmount: data.minOrderAmount || 0,
            maxDiscountAmount: data.discountType === 'percentage' ? (data.maxDiscountAmount || null) : null,
            expiryDate: data.expiryDate || null,
            maxUsageCount: data.maxUsageCount || null,
            isSingleUsePerUser: data.isSingleUsePerUser ? 1 : 0,
            isActive: data.isActive ? 1 : 0
        }
        let apiCall = "";
        if(InputFields.rowId) {
            apiCall = await ajaxCall.patchCall(`${config.api.generic}/offer-code`, postData, token);
        } else {
            apiCall = await ajaxCall.postCall(`${config.api.generic}/offer-code`, postData, token);
        }
        if(apiCall && apiCall.status) {
            setSubmitButton((InputFields.rowId) ? 'UPDATE RECORD' : 'SAVE RECORD');
            toast.info('Record updated successfully');
            reset();
            setDisableSubmitButton(false);
            loadapidata(apidataparams);
        } else {
            setSubmitButton((InputFields.rowId) ? 'UPDATE RECORD' : 'SAVE RECORD');
            toast.error(apiCall && apiCall.context.message || 'Something went wrong. Please try again :(');
            setDisableSubmitButton(false);
        }
    }

    React.useEffect(() => {
        async function loadComponent() {
            setShow(true);
        }

        async function fetchData() {
            if (rowid) {
                let apiCall = await ajaxCall.getCall(`${config.api.generic}/offer-code/row`, {
                    rowId: (rowid) ? rowid : 0
                }, token);
                if(apiCall && apiCall.status) {
                    let d = apiCall.context.message.data[0];
                    let onLoadData = {
                        rowId: rowid || 0,
                        code: d.code,
                        discountType: d.discount_type,
                        discountValue: d.discount_value,
                        minOrderAmount: d.min_order_amount,
                        maxDiscountAmount: d.max_discount_amount || "",
                        expiryDate: formatDateForInput(d.expiry_date),
                        maxUsageCount: d.max_usage_count || "",
                        isSingleUsePerUser: parseInt(d.is_single_use_per_user),
                        isActive: parseInt(d.is_active)
                    }
                    setInputFields(onLoadData);
                    setNotification({ status: false });
                } else {
                    setNotification({ status: true, message: 'Sorry something went wrong while fetching record :(' });
                }
            }
        }
        fetchData();
        loadComponent();
    }, []);

    return (
        <>
            <Modal show={Show} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
                <Modal.Header>
                    <Modal.Title>{rowid ? 'Update Offer Code' : 'Add Offer Code'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container>
                        <Row>
                            <form action="" method="" className="p-sm-1" onSubmit={handleSubmit(onSubmit)}>
                                <Row>
                                    {(Notification.status) ? <Col md="12" className="text-center">{Notification.message}</Col> : <>
                                        <Col md="12">
                                            <div className="text-left mt-3 vt-txt-dark-blue">
                                                <h4><b>Offer Code Info</b></h4>
                                                <hr />
                                            </div>
                                        </Col>
                                        <Col md="6" className="mt-3">
                                            <label className="form-label fs-14rem fw-bold">Offer Code</label>
                                            <input type="text" defaultValue={InputFields.code} className="form-control text-uppercase" {...register("code", { required: true, minLength: 2, maxLength: 50 })} disabled={disabledField} placeholder="e.g. FLAT100" />
                                            <small className="form-text text-danger">
                                                {errors.code?.type === "required" && "Offer code is mandatory"}
                                            </small>
                                        </Col>
                                        <Col md="6" className="mt-3">
                                            <label className="form-label fs-14rem fw-bold">Discount Type</label>
                                            <Controller
                                                name='discountType'
                                                defaultValue={InputFields.discountType}
                                                rules={{required: true}}
                                                control={control}
                                                render={({field}) => (
                                                    <select value={field.value || ""} className="form-control custom-select" onChange={(e) => {updateChangeEvent(e, field)}} disabled={disabledField}>
                                                        <option value="">Choose...</option>
                                                        <option value="flat">Flat (Rs)</option>
                                                        <option value="percentage">Percentage (%)</option>
                                                    </select>
                                                )}
                                            />
                                            <small className="form-text text-danger">
                                                {errors.discountType?.type === "required" && "Discount type is mandatory"}
                                            </small>
                                        </Col>
                                        <Col md="4" className="mt-3">
                                            <label className="form-label fs-14rem fw-bold">Discount Value</label>
                                            <input type="number" step="0.01" defaultValue={InputFields.discountValue} className="form-control" {...register("discountValue", { required: true, min: 0.01 })} disabled={disabledField} placeholder="e.g. 100 or 10" />
                                            <small className="form-text text-danger">
                                                {errors.discountValue?.type === "required" && "Discount value is mandatory"}
                                            </small>
                                        </Col>
                                        <Col md="4" className="mt-3">
                                            <label className="form-label fs-14rem fw-bold">Min Order Amount</label>
                                            <input type="number" step="0.01" defaultValue={InputFields.minOrderAmount} className="form-control" {...register("minOrderAmount")} disabled={disabledField} placeholder="e.g. 500" />
                                        </Col>
                                        {(watchDiscountType === 'percentage' || InputFields.discountType === 'percentage') && (
                                            <Col md="4" className="mt-3">
                                                <label className="form-label fs-14rem fw-bold">Max Discount Amount</label>
                                                <input type="number" step="0.01" defaultValue={InputFields.maxDiscountAmount} className="form-control" {...register("maxDiscountAmount")} disabled={disabledField} placeholder="e.g. 200" />
                                                <small className="form-text text-muted">Caps percentage discount</small>
                                            </Col>
                                        )}
                                        <Col md="4" className="mt-3">
                                            <label className="form-label fs-14rem fw-bold">Expiry Date</label>
                                            <input type="datetime-local" defaultValue={InputFields.expiryDate} className="form-control" {...register("expiryDate")} disabled={disabledField} />
                                            <small className="form-text text-muted">Leave empty for no expiry</small>
                                        </Col>
                                        <Col md="4" className="mt-3">
                                            <label className="form-label fs-14rem fw-bold">Max Usage Count</label>
                                            <input type="number" defaultValue={InputFields.maxUsageCount} className="form-control" {...register("maxUsageCount")} disabled={disabledField} placeholder="e.g. 100" />
                                            <small className="form-text text-muted">Leave empty for unlimited</small>
                                        </Col>
                                        <Col md="4" className="mt-3 d-flex align-items-end">
                                            <div>
                                                <div className="form-check mb-2">
                                                    <input type="checkbox" defaultChecked={InputFields.isSingleUsePerUser} className="form-check-input" {...register("isSingleUsePerUser")} disabled={disabledField} />
                                                    <label className="form-check-label fs-14rem fw-bold">Single Use Per User</label>
                                                </div>
                                                <div className="form-check">
                                                    <input type="checkbox" defaultChecked={InputFields.isActive} className="form-check-input" {...register("isActive")} disabled={disabledField} />
                                                    <label className="form-check-label fs-14rem fw-bold">Active</label>
                                                </div>
                                            </div>
                                        </Col>
                                        {(orginfo.roleId === 1 || orginfo.roleId === 2) ? <Col md="12" className="text-end">
                                            <Button variant="primary" type="submit" disabled={DisableSubmitButton} className="vt-primary-btn border-0 text-end text-white mt-4 fs-14rem">{SubmitButton}</Button>
                                        </Col> : null }
                                    </>}
                                </Row>
                            </form>
                        </Row>
                    </Container>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" className="fs-14rem" onClick={hideModal}>Close</Button>
                </Modal.Footer>
            </Modal>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </>
    )
}

export default FormModal;
